import React, { useEffect, useState } from "react";
// import logo from './logo.svg';
import "./Leaderbord.scss";
import logo from "../Images/ge-healthcare-logo-white.png";
import ReturnHome from "../Components/ReturnHome";
import { useParams, useNavigate } from "react-router";
import ModalCover from "../Components/ModalCover";
import ModalButtonsDisplay from "../Components/ModalButtonsDisplay";
import rewardImage from "../Images/reward.png";
import viewNavigate from "../Utils/viewNavigate";
import useIdle from "../Hooks/useIdle";

const IndividualResult = (props) => {
  /**@type {Array} */
  const users = props.users;
  const isIdle = useIdle();
  const usersTrimmed = users.slice(0, 10);
  const userData = props.userData;
  const [playerIndex, setPlayerIndex] = useState(0);
  useEffect(() => {
    const playerScore = userData.totalScore;
    const indexRaw = users.findIndex((elem) => elem.totalScore < playerScore);
    const index = indexRaw === -1 ? users.length : indexRaw;
    setPlayerIndex(index);
    const timeO = setTimeout(() => {
      viewNavigate(navigate, `/`);
    }, 60000);
    return () => {
      clearTimeout(timeO);
    };
  }, []);
  let navigate = useNavigate();
  const [retunHome, setRetunHome] = useState(false);

  return (
    <div className="holder-leaderboard">
      <div className="container-leaderboard">
        <img src={logo} alt="GE HealthCare" className="logo-leaderboard" />
        <p className="leaderboard-title">Leaderboard</p>
        <div className="leaderboard-list">
          {usersTrimmed.map((player, index) => {
            const addPlayer = playerIndex === index;
            const additionalPlayer = index >= playerIndex;
            const realisticIndex = index >= playerIndex ? index + 1 : index + 0;
            const firstPlayers = realisticIndex < 3;
            return (
              <>
                {addPlayer && (
                  <>
                    <div className="line-between "></div>
                    <div
                      key={playerIndex + 1}
                      className="player-leaderboard last-player"
                    >
                      <span className="rank">{playerIndex + 1}</span>
                      {playerIndex < 4 && <img src={rewardImage} />}
                      <span className="name-leaderbord">
                        {userData.userName}
                      </span>
                      <span className="points">
                        {userData.totalScore} Points
                      </span>
                    </div>
                  </>
                )}
                {(!additionalPlayer || index !== 9) && (
                  <>
                    <div className="line-between"></div>
                    <div
                      key={realisticIndex + 1}
                      className={`player-leaderboard ${
                        firstPlayers ? "first-players" : ""
                      }`}
                    >
                      <span className="rank">{realisticIndex + 1}</span>
                      {firstPlayers && <img src={rewardImage} />}
                      <span className="name-leaderbord">{player.userName}</span>
                      <span className="points">{player.totalScore} Points</span>
                    </div>
                  </>
                )}
              </>
            );
          })}
          <div className="line-between"></div>
        </div>
        {playerIndex >= usersTrimmed.length && (
          <>
            {playerIndex >= 10 && (
              <>
                <p className="last-player-dot">...</p>
                <div className="line-between"></div>
              </>
            )}
            <div className="player-leaderboard last-player">
              <span className="rank">{playerIndex + 1}</span>
              <span className="name-leaderbord">{userData.userName}</span>
              <span className="points">{userData.totalScore} Points</span>
            </div>
            <div className="line-between"></div>
          </>
        )}
        <div className="bottom-actions-leaderbord">
          <div></div>
          {/* <ReturnHome
            style={{ color: "white" }}
            white={true}
            onClick={() => setRetunHome(true)}
          /> */}
          <button
            onClick={() => viewNavigate(navigate, `/`)}
            className="skip-button"
          >
            New Game
          </button>
        </div>
      </div>
      {retunHome && (
        <ModalCover>
          <ModalButtonsDisplay
            title={"Are you sure?"}
            text={"The game will end, and you can start a new session."}
            denyText={"Cancel"}
            deny={() => {
              setRetunHome(false);
            }}
            accept={() => {
              viewNavigate(navigate, `/`);
            }}
            acceptText={"Retun To Home"}
          />
        </ModalCover>
      )}
    </div>
  );
};
export default IndividualResult;
